import script from "./PastaCustomizationModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./PastaCustomizationModal.vue?vue&type=script&setup=true&lang=ts"

import "./PastaCustomizationModal.vue?vue&type=style&index=0&id=40843040&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40843040"]])

export default __exports__